// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OnboardingContainer_wrapper__2sUHT","wrapperAction":"OnboardingContainer_wrapperAction__1u07z"};